const $ = jQuery.noConflict();

'use strict';
const Drops = {

	$domNavItemTitle: $('.js-drops__nav-item-title'),
	$domDropsNavSub: $('.js-drops__nav-wrap-sub'),

	$domBoxWrapper: $('.drops__items-box-wrapper'),

	$domSubNavLink: $('.js-drops__nav-item-sub'),
	$domSubnavItem: $('.js-drops__items'),

	strItemTop: '.js-drops__item-top',
	strItemBottom: '.js-drops__items-bottom',

	classActive: 'active',
	classSubActive: 'sub-active',

	init: function() {
		this.navFunctionality();
		this.itemDrop();
		/* this.navTabs();
		this.subNavTabs(); */
		this.loadHover();
	},

	loadHover: () => {

		$('.drops__item').each(function(e, obj) {
			if(!$(obj).find('.js-drops__items-bottom').length) {
				$(obj).addClass('prevent-click');
			}
		});
	},

	navFunctionality: () => {
		Drops.$domNavItemTitle.on('click', function() {
			if(!$(this).parent().hasClass(Drops.classActive)) {
				Drops.$domNavItemTitle.parents('.js-drops__nav-item').removeClass(Drops.classActive);
				$(this).parent().addClass(Drops.classActive);

				if($(window).width() > 576) {
					$('.js-drops__nav-wrap-sub').stop().slideUp();
					$(this).parent().find('.js-drops__nav-wrap-sub').stop().slideDown(300);
				}else {
					$('.js-drops__nav-wrap-sub').stop().fadeOut();
					$(this).parent().find('.js-drops__nav-wrap-sub').stop().fadeIn(300);
				}
			}
		});
	},

	itemDrop: () => {
		$(Drops.strItemTop).each(function() {
			$(this).on('click', function() {
				if(!$(this).parent().hasClass(Drops.classActive)) {
					$(Drops.strItemTop).parent('.drops__item').removeClass(Drops.classActive);
					$(Drops.strItemBottom).stop().slideUp();
					$(this).parent().addClass(Drops.classActive).find($(Drops.strItemBottom)).stop().slideDown();
				}else {
					$(this).parent().removeClass(Drops.classActive).find($(Drops.strItemBottom)).stop().slideUp();
				}
			});
		});
	},
};
export default Drops;
